import api from './../services/api.js'

export default {
  namespaced: true,
  state: {
    mapData: null,
    mapDataLoaded: false
  },
  getters: {
    getMapData: (state) => {
      return state.mapData
    }
  },
  mutations: {
    setMapData: (state, data) => {
      state.mapData = data
    },
    setMapLoaded: (state, data) => {
      state.mapDataLoaded = data
    }
  },
  actions: {
    getMapData: (context) => {
      api.getDataForSoundMap().then((resp) => {
        const data = resp.data.map((item) => {
          item.fields.coordinates = [parseFloat(item.fields.latitude), parseFloat(item.fields.longitude)]
          return item.fields
        })
        context.commit('setMapLoaded', true)
        context.commit('setMapData', data)
      })
    }
  }
}
